import React, { useState } from "react";
import "./Login.css";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const Login = () => {
  const [emailLogin, setEmailLogin] = useState("");
  const [passwordLogin, setPasswordLogin] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const { handleLogin } = useAuth();

  const [errorMessage, setErrorMessage] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const navigate = useNavigate();

  const validateForm = () => {
    if (!emailLogin || !passwordLogin) {
      setErrorMessage("Please fill all fields.");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(emailLogin)) {
      setErrorMessage("Please enter a valid email.");
      return false;
    }

    return true;
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const result = await handleLogin({
      emailLogin,
      passwordLogin,
    });

    if (result.success) {
      setSuccessMsg(result.message);
      setErrorMessage("");

      setTimeout(() => {
        navigate("/");
      }, 1000);
    } else {
      setErrorMessage(result.message);
      setSuccessMsg("");
    }
  };

  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center py-5"
      style={{
        background:
          "linear-gradient(135deg,#2563eb 0%,#4f46e5 45%,#7c3aed 100%)",
      }}
    >
      <div className="container">

        <div className="row justify-content-center align-items-center">

          {/* Left Side */}

          <div className="col-lg-6 d-none d-lg-block">

            <div className="text-white pe-5">

              <h1
                className="fw-bold mb-4"
                style={{ fontSize: "52px" }}
              >
                Welcome Back 👋
              </h1>

              <p
                className="fs-5"
                style={{ opacity: 0.9 }}
              >
                Sign in to access your orders, wishlist,
                exclusive offers and continue your premium
                shopping experience with Glamira.
              </p>

              <div className="mt-5">

                <div className="d-flex align-items-center mb-4">
                  <i className="fa-solid fa-shield-halved fs-3 me-3"></i>
                  <span>100% Secure Login</span>
                </div>

                <div className="d-flex align-items-center mb-4">
                  <i className="fa-solid fa-truck-fast fs-3 me-3"></i>
                  <span>Fast Order Tracking</span>
                </div>

                <div className="d-flex align-items-center">
                  <i className="fa-solid fa-star fs-3 me-3"></i>
                  <span>Premium Shopping Experience</span>
                </div>

              </div>

            </div>

          </div>

          {/* Right Side */}

          <div className="col-lg-5 col-md-8">

            <div
              className="card border-0 shadow-lg"
              style={{
                borderRadius: "25px",
                backdropFilter: "blur(20px)",
              }}
            >
              <div className="card-body p-5">

                <div className="text-center mb-4">

                  <div
                    className="mx-auto rounded-circle d-flex align-items-center justify-content-center mb-3"
                    style={{
                      width: 80,
                      height: 80,
                      background:
                        "linear-gradient(135deg,#2563eb,#7c3aed)",
                      color: "#fff",
                      fontSize: "32px",
                    }}
                  >
                    <i className="fa-solid fa-user"></i>
                  </div>

                  <h2 className="fw-bold">
                    Login
                  </h2>

                  <p className="text-muted">
                    Access your account securely
                  </p>

                </div>

                {errorMessage && (
                  <div className="alert alert-danger rounded-4">
                    {errorMessage}
                  </div>
                )}

                {successMsg && (
                  <div className="alert alert-success rounded-4">
                    {successMsg}
                  </div>
                )}

                <form onSubmit={handleLoginSubmit}>

                  {/* Email */}

                  <div className="mb-4">

                    <label className="fw-semibold mb-2">
                      Email Address
                    </label>

                    <div className="position-relative">

                      <i
                        className="fa-solid fa-envelope position-absolute"
                        style={{
                          top: 18,
                          left: 18,
                          color: "#94a3b8",
                        }}
                      ></i>

                      <input
                        type="email"
                        className="form-control rounded-pill py-3 ps-5"
                        placeholder="Enter your email"
                        value={emailLogin}
                        onChange={(e) =>
                          setEmailLogin(e.target.value)
                        }
                      />

                    </div>

                  </div>

                  {/* Password */}

                  <div className="mb-3">

                    <label className="fw-semibold mb-2">
                      Password
                    </label>

                    <div className="position-relative">

                      <i
                        className="fa-solid fa-lock position-absolute"
                        style={{
                          top: 18,
                          left: 18,
                          color: "#94a3b8",
                        }}
                      ></i>

                      <input
                        type={
                          showPassword
                            ? "text"
                            : "password"
                        }
                        className="form-control rounded-pill py-3 ps-5 pe-5"
                        placeholder="Enter password"
                        value={passwordLogin}
                        onChange={(e) =>
                          setPasswordLogin(e.target.value)
                        }
                      />

                      <i
                        className={`fa-solid ${
                          showPassword
                            ? "fa-eye-slash"
                            : "fa-eye"
                        } position-absolute`}
                        style={{
                          top: 18,
                          right: 18,
                          cursor: "pointer",
                          color: "#94a3b8",
                        }}
                        onClick={() =>
                          setShowPassword(!showPassword)
                        }
                      ></i>

                    </div>

                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-4">

                    <Link
                      to="/forget-password"
                      className="text-decoration-none fw-semibold"
                      style={{
                        float: "inline-end"
                      }}
                    >
                      Forgot Password?
                    </Link>

                  </div>

                  <button
                    type="submit"
                    className="btn w-100 text-white rounded-pill py-3 fw-bold"
                    style={{
                      background:
                        "linear-gradient(135deg,#2563eb,#4f46e5,#7c3aed)",
                      border: "none",
                    }}
                  >
                    Login →
                  </button>

                  <div className="text-center mt-4">

                    <span className="text-muted">
                      Don't have an account?
                    </span>

                    <Link
                      to="/register"
                      className="fw-bold text-decoration-none ms-2"
                    >
                      Create Account
                    </Link>

                  </div>

                </form>

                <hr className="my-4" />

                <div className="text-center text-muted small">

                  🔒 Secure Login • 🚚 Fast Checkout • ⭐ Trusted by Thousands

                </div>

              </div>
            </div>

          </div>

        </div>

      </div>
    </div>
  );
};

export default Login;